'use strict';

import template from './fb_join_modal.html';

export default {
  bindings: {
    done: '&',
    guide: '<'
  },
  template: template,
  controller: function($state, social, userModel, requestReferenceModal, referenceCheck ) {
    'ngInject';

    this.facebook = {
      cssClass: 'Button--fb',
      iconCssClass: 'Icon-fb',
      name: 'fb',
      displayName: 'Facebook',
      social: true
    };

    this.connectWithFb = function () {
      this.isLoading = true;

      social.login('fb').then(() => {
        var userId = userModel.item.id;
        var userToReviewId = this.guide.id;

        referenceCheck.reviewLeft(userId, userToReviewId).then((result) => {
          if (!result.reviewLeft) {
            requestReferenceModal.open(this.guide);
          }

          this.done({
            result: result
          });

        }).finally(() => {
          delete this.isLoading;
        });
      });
    };

    this.infoTerms =  function () {
      $state.go('info.terms');
      this.done({ reason: 1 });
    };
    this.infoPrivacy =  function () {
      $state.go('info.privacy');
      this.done({ reason: 1 });
    };
  }
};



// WEBPACK FOOTER //
// ./app/src/components/request_reference/fb_join_modal/fb_join_modal.js